var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { ClientError } from './errors.js';
/**
 * Owner Olympus client
 */
class ClientInstance {
    constructor(baseURL, getRequestSettings, { defaultHeaders, onRequestError, onResponseError, formatRequest, formatResponse, } = {}) {
        const headers = Object.assign({ Accept: 'application/json' }, defaultHeaders);
        this.instance = axios.create({
            baseURL,
            headers,
            withCredentials: true,
        });
        this.instance.interceptors.request.use((req) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const { audience, client, csrfToken, bearerToken } = yield getRequestSettings();
            if (audience) {
                req.headers['X-PB-Audience'] =
                    (_b = (_a = req.headers) === null || _a === void 0 ? void 0 : _a['X-PB-Audience']) !== null && _b !== void 0 ? _b : audience;
            }
            if (client) {
                req.headers['X-PB-Client'] = (_d = (_c = req.headers) === null || _c === void 0 ? void 0 : _c['X-PB-Client']) !== null && _d !== void 0 ? _d : client;
            }
            if (csrfToken) {
                req.headers['X-CSRFToken'] = (_f = (_e = req.headers) === null || _e === void 0 ? void 0 : _e['X-CSRFToken']) !== null && _f !== void 0 ? _f : csrfToken;
            }
            if (bearerToken) {
                req.headers.authorization = ((_g = req.headers) === null || _g === void 0 ? void 0 : _g.Authorization)
                    ? [`Bearer ${bearerToken}`, (_h = req.headers) === null || _h === void 0 ? void 0 : _h.Authorization].join(', ')
                    : `Bearer ${bearerToken}`;
            }
            if (formatRequest)
                req = yield formatRequest(req);
            return req;
        }), onRequestError);
        if (formatResponse || onResponseError)
            this.instance.interceptors.response.use(formatResponse, onResponseError);
    }
    exec(method, path, req, knownErrors) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                const { data } = yield this.send(method, path, req);
                return data;
            }
            catch (error) {
                if (axios.isAxiosError(error) &&
                    knownErrors.includes((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.code)) {
                    const { code, message, status, payload } = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data;
                    throw new ClientError(code, message, status, payload);
                }
                throw error;
            }
        });
    }
    send(method, basePath, req) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                headers: req.headers,
            };
            if (req.query && Object.keys(req.query).length) {
                options.params = req.query;
            }
            const path = this.formatPath(basePath, req);
            switch (method) {
                case 'DELETE':
                    return yield this.instance.delete(path, options);
                case 'GET':
                    return yield this.instance.get(path, options);
                case 'PATCH':
                    return yield this.instance.patch(path, req.body, options);
                case 'POST':
                    return yield this.instance.post(path, req.body, options);
                case 'PUT':
                    return yield this.instance.put(path, req.body, options);
            }
        });
    }
    formatPath(path, request) {
        var _a;
        for (const [key, value] of Object.entries((_a = request.params) !== null && _a !== void 0 ? _a : {})) {
            path = path.replace(`{${key}}`, value);
        }
        return path;
    }
}
export default ClientInstance;
//# sourceMappingURL=instance.js.map